var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYanport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#abb3ba",
  d: "M8.77 9h22.626a.772.772 0 0 1 .675 1.144l-11.353 20.46a.77.77 0 0 1-1.35-.003L8.096 10.141A.77.77 0 0 1 8.77 9m12.058 8v10.23l8.686-15.652zm-.744-1.291 8.468-5.286H11.613zm-.745 11.679V16.999l-8.722-5.443.004.01z"
})));
export default SvgYanport;